import { render, staticRenderFns } from "./complaint-type.vue?vue&type=template&id=8b2bee0c"
import script from "./complaint-type.vue?vue&type=script&lang=js"
export * from "./complaint-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports